import {Grid, Link, Typography} from "@mui/material";
import imgUrl from "../../common/imageHelper";
import {incrementCounter} from "./DriverPortalService";

export function Faq() {
    function onFaqClicked() {
        incrementCounter("driver-portal-faq-clicked");
    }

    return (
        <Grid container justifyContent='center' align='left' sx={{boxShadow: 3}}>
            <Grid item xs={3}>
                <img width="100%" height="100%" src={imgUrl('/driver-portal-faq.png')}/>
            </Grid>
            <Grid item xs={9} align='left' sx={{px: 2, py: 1}}>
                <Typography>Any questions about your rental?</Typography>
                <br/>
                <Typography>
                    <Link href="https://www.hertz.com/rentacar/rental-car-deals/uber-rentals" target="_blank" onClick={onFaqClicked}
                          color="#355AD8">Read our FAQ
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ top: 2, position: 'relative', marginLeft: 5}}>
                            <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="#355AD8"/>
                        </svg>
                    </Link></Typography>
            </Grid>
        </Grid>
    )
}